module.exports = __webpack_public_path__ + "static/img/celoscope-detail-10.cecf2bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/celoscopepic/celoscope-detail-10.jpg
// module id = Lq3n
// module chunks = 52